<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1387 17.3397L11.217 17.4285C11.5563 17.7677 12.0901 17.7938 12.4593 17.5067L12.548 17.4285L19.1362 10.8402L19.1752 10.7988L19.2271 10.735L19.2946 10.6303L19.3449 10.5242L19.3782 10.425L19.4054 10.2858L19.4119 10.1747L19.4092 10.1039L19.3929 9.98576L19.3651 9.88089L19.3238 9.77635L19.2745 9.6846L19.2051 9.58602L19.1362 9.50916L12.548 2.92093C12.1804 2.55338 11.5845 2.55338 11.217 2.92093C10.8777 3.2602 10.8516 3.79407 11.1387 4.16329L11.217 4.25195L16.1968 9.2335H1.52955C1.00976 9.2335 0.588379 9.65488 0.588379 10.1747C0.588379 10.6945 1.00976 11.1159 1.52955 11.1159H16.1987L11.217 16.0974C10.8777 16.4367 10.8516 16.9706 11.1387 17.3397Z"
      class="fill-current"
    />
  </svg>
</template>
